import * as React from "react";
import Section from "../../../core/layout/main/section/Section";
import * as classNames from "./BlogLastesArticlesSection.module.scss";
import ArticleCardVerticalBlock from "../blocks/article-card-vertical/ArticleCardVerticalBlock";
import { articleUrl } from "../../../../utils/routeLib";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import CtaLink from "../../../core/cta-link/CtaLink"
const BlogLastesArticlesSection = ({ title, articles ,ctaLink ,buttonLabel }) => {
  const [swiper, setSwiper] = React.useState(null);
  const [currentSlide, setCurrentSlide] = React.useState(0);

  const handlePrevClick = () => {
    if (swiper) {
      swiper.slidePrev();
      setCurrentSlide(swiper.activeIndex);
    }
  };

  const handleNextClick = () => {
    if (swiper) {
      swiper.slideNext();
      setCurrentSlide(swiper.activeIndex);
    }
  };

  return (
    <Section className={`${classNames.sectionBg}`} container="xxlarge">
      <div className="text-center mb-4">
        <h2>{title}</h2>
      </div>
      <Swiper
        
        slidesPerView={3}
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 46,
          },
          768: {
            slidesPerView: 2.1,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 48,
          },
        }}
        onSwiper={(swiper) => setSwiper(swiper)}
        onSlideChange={(swiper) => setCurrentSlide(swiper.activeIndex)}
      >
        {articles.map((art, index) => (
          <SwiperSlide key={index}>
            <ArticleCardVerticalBlock articles={art} url={articleUrl(art)} />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className={`${classNames.btnPaginationContainerBlogLastesArticlesSection}`}>
          <div className={`${classNames.paginationViewBlogLastesArticlesSection}`}>
            <button
              id="BlogLastesArticlesSection-prev-btn"
              className="btn unstyled"
              onClick={handlePrevClick}
            >
              <img
                className="image"
                src="https://media.paritel.fr/paritel-www-dev/assets/pagination_arrow_left_e09dd1e248.svg"
                alt="fleche gauche"
              />
            </button>
            <span id="BlogLastesArticlesSection-pagination-current">{currentSlide + 1}</span>
            <progress
              id="BlogLastesArticlesSection-progressBar"
              max={articles.length - 1}
              value={currentSlide===0 ?1:currentSlide}
            >
              {((currentSlide + 1) / articles.length) * 100}%
            </progress>
            <span id="BlogLastesArticlesSection-pagination-total">{articles.length}</span>
            <button
              id="BlogLastesArticlesSection-next-btn"
              className="btn unstyled"
              onClick={handleNextClick}
            >
              <img
                className="image"
                src="https://media.paritel.fr/paritel-www-dev/assets/pagination_arrow_right_32981af1d4.svg"
                alt="fleche droite"
              />
            </button>
          </div>
 
      </div>
      <div className={`text-center mb-4 ${classNames.ButtonsStyles}`}>
       <CtaLink ctaLink={ctaLink} className="button classique large primary">{buttonLabel}</CtaLink> 
      </div>

    </Section>
  );
};

export const name = "BlogLastesArticlesSection";

export const init = (componentData, pageContext) => {
  console.log("pageContext: ", componentData);

  return (
    <BlogLastesArticlesSection
      title={
        componentData?.BlogLastesArticlesSectionTitle
          ? componentData?.BlogLastesArticlesSectionTitle
          : "Découvrez nos derniers articles"
      }
      articles={pageContext.lastesArticles ? pageContext.lastesArticles : []}
      ctaLink={pageContext.buttonCtaLink ? pageContext.buttonCtaLink : {}}
      buttonLabel={pageContext.buttonLabel ? pageContext.buttonLabel : "Consulter plus d'articles sur notre blog"}
    />
  );
};

export default BlogLastesArticlesSection;
